import React from 'react';
import {
  DropdownWrapper,
  DropdownItemWrapper,
} from './NavigationDropdown.style';

interface DropdownMenuProps {
  children: React.ReactNode;
}

interface NavigationDropdownInterface extends React.FC<DropdownMenuProps> {
  Item: typeof NavigationDropdownItem;
}

const NavigationDropdown: NavigationDropdownInterface = ({ children }) => {
  return <DropdownWrapper>{children}</DropdownWrapper>;
};

const NavigationDropdownItem: React.FC<{
  label: React.ReactNode;
  link?: string;
  onClick?: () => void;
}> = ({ label, link, onClick }) => {
  return (
    <DropdownItemWrapper>
      <a href={link} onClick={onClick}>
        {label}
      </a>
    </DropdownItemWrapper>
  );
};

NavigationDropdown.Item = NavigationDropdownItem;

export default NavigationDropdown;
